import * as types from './types';

export const resetNotification = () => dispatch => {
  dispatch({ type: types.RESET_NOTIFICATION });
};

export const displayNotification = notificationData => dispatch => {
  dispatch({
    type: types.NOTIFICATION,
    payload: { notificationData },
  });
};
